import React, { Component, useEffect, useState } from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import { Row, Col, Card, CardBody, Container, Spinner, Button } from 'reactstrap';
import useGet from '../../../../helpers/hooks/useGet';
import useDelete from '../../../../helpers/hooks/useDelete';
import dayjs from 'dayjs';

const columns = [
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Announcement',
    field: 'content',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Content Type',
    field: 'contentType',
    width: 150,
  },
  {
    label: 'Published Areas',
    field: 'districts',

    width: 150,
  },
  {
    label: 'Farmers Growing',
    field: 'vegetables',

    width: 150,
  },
  {
    label: 'Languages',
    field: 'languages',

    width: 150,
  },
  {
    label: 'Farm Size',
    field: 'fieldAreas',

    width: 150,
  },
  {
    label: 'Post On',
    field: 'postOn',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Processed',
    field: 'processed',

    width: 100,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    width: 100,
  },
  {
    label: '',
    field: 'action',
    sort: 'disabled',
    width: 100,
  },
];
const Announcements = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Adjust as needed
  const pagesAmount = 250; // Setting pages amount to 100

  const [announcementsError, setError] = useState();
  const [announcements, setData] = useState();
  const [announcementsLoading, setLoading] = useState(false);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    if (currentPage < pagesAmount) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const call = async (offset) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/${`/announcements?filter[order]=createdAt DESC&filter[limit]=${itemsPerPage}&filter[offset]=${offset}`}`
      );
      const result = await response.json();
      if (response.ok) {
        setData(result);
      } else {
        setError(result);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage === 1) {
      call(currentPage - 1);
    } else {
      call((currentPage - 1) * 10);
    }
  }, [currentPage]);

  //   const [announcements, announcementsError, announcementsLoading, fetchPosts] = useGet(
  //     '/announcements?filter[order]=createdAt DESC&filter[limit]=10&filter[offset]=0',
  //     true
  //   );
  const [deleteCall, data, error, deleteLoading] = useDelete();
  const handleDelete = (x) => {
    if (window.confirm('Are you sure?')) {
      deleteCall(`/announcements/${x.id}`).then((e) => call((currentPage - 1) * 10));
    }
  };

  // Create pagination range
  const pageNumbers = [];
  for (let i = 1; i <= pagesAmount; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    if (
      number === 1 ||
      number === pagesAmount ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      return (
        <MDBPageItem active={number === currentPage} key={number}>
          <MDBPageNav onClick={() => handlePageClick(number)} className="page-link-custom">
            {number}
          </MDBPageNav>
        </MDBPageItem>
      );
    } else if (number === currentPage - 2 || number === currentPage + 2) {
      return (
        <MDBPageItem key={number}>
          <MDBPageNav className="page-link-custom">...</MDBPageNav>
        </MDBPageItem>
      );
    }
    return null;
  });

  return (
    <React.Fragment>
      <Row>
        {announcementsLoading || deleteLoading ? (
          <div className="text-center w-100">
            <Spinner className="mr-2" color="primary" />
          </div>
        ) : (
          <Col xs={12}>
            <MDBDataTable
              responsive
              bordered
              searching={false}
              paging={false}
              data={{
                columns,
                rows: announcements?.map((x) => ({
                  ...x,
                  action: (
                    <>
                      <Button onClick={() => handleDelete(x)} size="sm" color="warning">
                        Delete
                      </Button>
                    </>
                  ),
                  name: x.name,
                  postOn: dayjs(x.postOn).format('DD/MM/YYYY'),
                  createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                  processed: x?.processed ? 'Yes' : 'No',
                  languages: x?.languages?.map((x) => x.name).join(', '),
                  vegetables: x?.vegetables?.map((x) => x.name).join(', '),
                  districts: x?.districts?.map((x) => x.name).join(', '),
                  fieldAreas: x?.fieldAreas?.map((x) => x.name).join(', '),
                  content:
                    x.contentType === 'TEXT' ? (
                      x.content
                    ) : x.contentType === 'IMAGE' ? (
                      <img src={x.content} className="avatar-md" />
                    ) : (
                      <video controls width="233" height="233" autoPlay={false} name="media">
                        <source src={x.content} type="video/mp4" />
                      </video>
                    ),
                })),
              }}
            />
            <MDBPagination className="mb-5 justify-content-center">
              <MDBPageItem disabled={currentPage === 1}>
                <MDBPageNav onClick={handlePrev} className="page-link-custom">
                  &laquo;
                </MDBPageNav>
              </MDBPageItem>
              {renderPageNumbers}
              <MDBPageItem disabled={currentPage === pagesAmount}>
                <MDBPageNav onClick={handleNext} className="page-link-custom">
                  &raquo;
                </MDBPageNav>
              </MDBPageItem>
            </MDBPagination>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default Announcements;
